<template>
<div>
<div class="homeLandingLogin"></div>
<div class="row justify-content-center mt-4">
<div class="col-md-6" id="contact">
<h2>Contact Us</h2>
<p></p>
<b-form @submit.prevent="validateBeforeSubmit" autocomplete="off">
  <div class="row">
    <div class="col-md-6">
      <label class="label">Name</label>
      <p class="control has-icon has-icon-right">
      <b-input name="Your Name" v-model="contact.Name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Your Name') }" type="text" placeholder=""/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Your Name')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Your Name')" class="help is-danger">{{ errors.first('Your Name') }}</span>
      </p>
    </div>
    <div class="col-md-6">
      <label class="label">Email</label>
      <p class="control has-icon has-icon-right">
        <b-input name="Email" v-model="contact.Email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" type="email" placeholder=""/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Email')" class="help is-danger">{{ errors.first('Email') }}</span>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label class="label">Subject</label>
      <p class="control has-icon has-icon-right">
        <b-textarea name="Subject" v-model="contact.Subject" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Subject') }" type="text" placeholder=""/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Subject')" class="help is-danger">{{ errors.first('Subject') }}</span>
      </p>
    </div>
    <div class="col">
      <label class="label">Phone</label>
    <p class="control has-icon has-icon-right">
      <masked-input name="Phone" v-model="contact.Phone" v-validate="" mask="(111) 111-1111" :class="{'form-control input': true, 'is-danger': errors.has('Phone') }" type="text" placeholder=""/>
      <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('Phone')" class="fa-1x"></font-awesome-icon>
      <span v-show="errors.has('Phone')" class="help is-danger">{{ errors.first('Phone') }}</span>
    </p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label class="label">Message</label>
      <p class="control has-icon has-icon-right">
        <b-textarea name="Message" v-model="contact.Message" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('Message') }" rows="5" type="textarea" placeholder=""/>
        <font-awesome-icon icon="exclamation-triangle" v-show="errors.has('name')" class="fa-1x"></font-awesome-icon>
        <span v-show="errors.has('Message')" class="help is-danger">{{ errors.first('Message') }}</span>
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2">
      <p class="control">
        <button class="btn btn-primary" type="submit">Submit</button>
      </p>
    </div>
    <div class="col-md-4" v-if="loading">
    </div>
  </div>
</b-form>
</div>
</div>

  <b-modal id="modal1" title="Thank you for contacting us" size="lg" centered hide-footer @hide="clearData">
    <h3 :class='sentClass'>{{message}}</h3>
  </b-modal>
</div>
</template>
<script>
import axios from 'axios'
import MaskedInput from 'vue-masked-input'
export default {
  name: 'ContactForm',
  components: {
    MaskedInput
  },
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      contact: {},
      message: '',
      sentClass: '',
      timer: '',
      loading: false,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.loading = true
          // Data is valid, so we can submit the form.
          let uri = this.apiUrl + 'contactus'
          axios.post(uri, this.contact, '').then((response) => {
            this.sentClass = 'text-success'
            this.message = 'Thank you for your contact request, we will be in touch as soon as possible.'
            this.loading = false
            this.$root.$emit('bv::show::modal', 'modal1')
          }).catch(() => {
            this.loading = false
            this.sentClass = 'text-danger'
            this.message = 'Something went wrong please try again later.'
            this.timer = setTimeout(() => { this.message = '' }, 10000)
          })
        }
      })
    },
    clearData () {
      this.contact = {}
      this.loading = false
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
    }
  }
}
</script>

<style>
#contact {
  margin: 0 auto;
  border: solid 1px #bbbbbb;
  padding:30px 40px;
  border-radius: 5px;
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/contactform.vue